import React, { useState } from 'react';
import { cancelBooking, cancelBookingNoPay } from "../../../api/apiRequests";
import MyInput from "../../shared/form/MyInput";
import MySubmit from "../../shared/form/MySubmit";
import PieceOfInfo from "../../shared/PieceOfInfo";
import useErrors from "../../../hooks/useErrors";

const ModalCancelation = ({ booking, afterCancel, changeModal }) => {
  const [refund, setRefund] = useState("")
  const { errors, captureErrors } = useErrors()

  const changeInfo = (event) => {
    if (event.target.value <= booking.totalPrice)
      setRefund(event.target.value)
    else
      alert("La devolución no puede superar el importe total.")
  };

  const submit = (event) => {
    event.preventDefault();
    if (errors.length < 1) {
      const cancelation = (booking.payment && booking.status !== "doubtful") ? 
        () => cancelBooking(booking.payment, refund) :
        () => cancelBookingNoPay(booking._id);

      cancelation()
        .then(async () => {
          await afterCancel();
          alert("La reserva se ha cancelado")
          changeModal(null);
        })
        .catch(() => {
          alert("No se ha podido realizar la cancelación.")
        })
    } else {
      alert("Todos los campos son obligatorios")
    }
  };

  const min = 0;
  const max = booking.totalPrice;
  return (
    <div className="bg-white p-5"
         style={{ minWidth: "300px", width: "90vw", maxWidth: "1000px", minHeight: "200px" }}>
      {booking.status === "doubtful" ?
        // <div className="d-flex justify-content-center align-items-center h-100 w-100">
        //   La reserva no se puede cancelar debido a que se está procesando en stripe
        // </div>
        <div className="d-flex justify-content-center align-items-center h-100 w-100">
          Pago no procesado
          <div className="row bg-danger ml-3">
            <MySubmit text="CANCELAR" className="bg-danger btn-danger" onClick={submit} />
          </div>
        </div>
      :
        <form onSubmit={submit} className="row h-100 align-items-center">
          <div className="col-12 d-lg-none mb-4">
            <PieceOfInfo title="Mínimo de devolución" children={min.toFixed(2) + " €"}/>
            <PieceOfInfo title="Máximo de devolución" children={max.toFixed(2) + " €"}/>
          </div>
          <div className="d-none d-lg-block col-6">
            <PieceOfInfo title="Mínimo de devolución" children={min.toFixed(2) + " €"} className="w-100"/>
            <PieceOfInfo title="Máximo de devolución" children={max.toFixed(2) + " €"} className="w-100"/>
          </div>
          <div className="col-12 col-lg-6">
            {booking.payment &&
            <MyInput title="Importe a devolver" type="number" name="refund" value={refund}
                    onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}/>}
            <div className="row bg-danger">
              <MySubmit text="CANCELAR" className="bg-danger btn-danger"/>
            </div>
          </div>
        </form>
      }

    </div>
  );
}

export default ModalCancelation
